export enum EditionMode {
    Artisan = 0,
    ArtisanSansMetre,
    ArtisanAvecMetre,
    Client,
    ClientAvecMetre,
    RealConcept,
    RealConceptAlerteSansMarge,
}
